import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
// import Ad from '@ifeng-fe/ui_pc_ad';

import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * 定义 Footer 组件
 */
class RightBanner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        // event: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.news_group_title}>
                <i className={styles.block} />
                <span className={styles.link_title}>{content.title}</span>
                <a className={styles.more} href={content.moreUrl} target="_blank" rel="noreferrer">
                    更多&gt;
                </a>
            </div>
        );
        // return footer;
    }
}

export default errorBoundary(RightBanner);
